import { useI18n } from "@/context/I18nContext";

export default function ApplicatorStub({ title }) {
  const { t } = useI18n();
  return (
    <div data-testid="applicator-stub">
      <h1 className="serif-head text-3xl lg:text-4xl mb-3">{t(title) || title}</h1>
      <div className="hair-border bg-white/[0.02] p-8 text-center">
        <p className="text-gray-400">This section is coming in the next phase of the ERRĀH Applicator Network.</p>
        <p className="text-[11px] text-gray-600 mt-3 max-w-xl mx-auto">{t("disclaimer")}</p>
      </div>
    </div>
  );
}
